<template>
  <div class="game-mz-labyrinth2">
    <canvas
      ref="board"
      :width="startGameConfig.board.width"
      :height="startGameConfig.board.height"
      class="board"
      :style="boardStyle"
    ></canvas>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="startGameConfig.board.width"
      :height="startGameConfig.board.height"
      :viewBox="viewBox"
      @mousedown="clickOnSvg"
      class="svg"
      :style="svgStyle"
    >
      <path :d="svgPath" style="fill: none; stroke: black; stroke-width: 2" />
      Sorry, your browser does not support inline SVG.
    </svg>
  </div>
</template>

<script>
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixin';
export default {
  name: 'mz-labyrinth2',
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      mainBoard: {},
      board: new Uint8ClampedArray(),
      mask: new Uint8ClampedArray(),
      boardStyle: {},
      svgStyle: {},
      offsetX: null,
      offsetY: null,
      svgPath: '',
      completed: false,
    };
  },
  methods: {
    getImageSrc(imageSrc) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        let cnv = document.createElement('canvas'),
          img = new Image(),
          ctx = cnv.getContext('2d');
        cnv.width = this.startGameConfig.board.width;
        cnv.height = this.startGameConfig.board.height;
        img.src = this.getImageSrc(url);
        img.addEventListener('load', () => {
          ctx.drawImage(img, 0, 0);
        });
        img.onload = () =>
          resolve(ctx.getImageData(0, 0, this.startGameConfig.board.width, this.startGameConfig.board.height));
        img.onerror = () => reject(console.log('Error loading image'));
      });
    },
    checkGameAction() {
      return this.completed;
    },
    check(r, x, y) {
      if (r == 1) {
        this.completed = true;
        this.$store.dispatch('checkGame');
      }
    },
    up(mx, my, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= ady; i++) {
        lx = mx;
        ly = my - i;
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          ly += 1;
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    down(mx, my, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= ady; i++) {
        lx = mx;
        ly = my + i;
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          ly -= 1;
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    left(mx, my, adx) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= adx; i++) {
        lx = mx - i;
        ly = my;
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          lx += 1;
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    right(mx, my, adx) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= adx; i++) {
        lx = mx + i;
        ly = my;
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          lx -= 1;
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    topRightX(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= adx; i++) {
        lx = mx + i;
        ly = Math.ceil(my - (i * ady) / adx);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          lx -= 1;
          ly = Math.ceil(my - ((i - 1) * ady) / adx);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    topRightY(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= ady; i++) {
        ly = my - i;
        lx = Math.floor(mx + (i * adx) / ady);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          ly += 1;
          lx = Math.floor(mx + ((i - 1) * adx) / ady);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    bottomRightX(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= adx; i++) {
        lx = mx + i;
        ly = Math.floor(my + (i * ady) / adx);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          lx -= 1;
          ly = Math.floor(my + ((i - 1) * ady) / adx);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    bottomRightY(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= ady; i++) {
        ly = my + i;
        lx = Math.floor(mx + (i * adx) / ady);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          ly -= 1;
          lx = Math.floor(mx + ((i - 1) * adx) / ady);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    topLeftX(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= adx; i++) {
        lx = mx - i;
        ly = Math.ceil(my - (i * ady) / adx);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          lx += 1;
          ly = Math.ceil(my - ((i - 1) * ady) / adx);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    topLeftY(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= ady; i++) {
        ly = my - i;
        lx = Math.ceil(mx - (i * adx) / ady);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          ly += 1;
          lx = Math.ceil(mx - ((i - 1) * adx) / ady);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    bottomLeftX(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= adx; i++) {
        lx = mx - i;
        ly = Math.floor(my + (i * ady) / adx);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          lx += 1;
          ly = Math.floor(my + ((i - 1) * ady) / adx);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    bottomLeftY(mx, my, adx, ady) {
      let i,
        lx = mx,
        ly = my;
      for (i = 1; i <= ady; i++) {
        ly = my + i;
        lx = Math.ceil(mx - (i * adx) / ady);
        if (this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4] > 0) {
          this.check(this.mask.data[ly * this.startGameConfig.board.width * 4 + lx * 4], lx, ly);
          ly -= 1;
          lx = Math.ceil(mx - ((i - 1) * adx) / ady);
          return { lx, ly };
        }
      }
      return { lx, ly };
    },
    clickOnSvg() {
      if (!this.completed) {
        let mx, my, dx, dy, adx, ady, lx, ly;
        if (this.offsetX === null) {
          mx = this.startGameConfig.board.startX;
          my = this.startGameConfig.board.startY;
        } else {
          mx = this.offsetX;
          my = this.offsetY;
        }
        dx = event.offsetX - mx;
        dy = event.offsetY - my;
        adx = Math.abs(dx);
        ady = Math.abs(dy);
        if (dx == 0) {
          if (dy < 0) {
            ({ lx, ly } = this.up(mx, my, ady));
          } else {
            ({ lx, ly } = this.down(mx, my, ady));
          }
        } else if (dy == 0) {
          if (dx < 0) {
            ({ lx, ly } = this.left(mx, my, adx));
          } else {
            ({ lx, ly } = this.right(mx, my, adx));
          }
        } else if (dx > 0) {
          if (dy < 0) {
            if (Math.max(adx, ady) == adx) {
              ({ lx, ly } = this.topRightX(mx, my, adx, ady));
            } else {
              ({ lx, ly } = this.topRightY(mx, my, adx, ady));
            }
          } else {
            if (Math.max(adx, ady) == adx) {
              ({ lx, ly } = this.bottomRightX(mx, my, adx, ady));
            } else {
              ({ lx, ly } = this.bottomRightY(mx, my, adx, ady));
            }
          }
        } else {
          if (dy < 0) {
            if (Math.max(adx, ady) == adx) {
              ({ lx, ly } = this.topLeftX(mx, my, adx, ady));
            } else {
              ({ lx, ly } = this.topLeftY(mx, my, adx, ady));
            }
          } else {
            if (Math.max(adx, ady) == adx) {
              ({ lx, ly } = this.bottomLeftX(mx, my, adx, ady));
            } else {
              ({ lx, ly } = this.bottomLeftY(mx, my, adx, ady));
            }
          }
        }
        if (this.startGameConfig.svg.continuedPath && this.offsetX != null) {
          this.svgPath += ' L' + lx + ' ' + ly;
        } else {
          this.svgPath = 'M' + mx + ' ' + my + ' L' + lx + ' ' + ly;
        }
        this.offsetX = lx;
        this.offsetY = ly;
      }
    },
    resetGameAction() {
      this.offsetX = null;
      this.offsetY = null;
      this.svgPath = '';
      this.completed = false;
    },
  },
  computed: {
    viewBox() {
      return '0 0 ' + this.startGameConfig.board.width + ' ' + this.startGameConfig.board.height;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
  created() {
    this.loadImage(this.startGameConfig.board.srcBoard).then((data) => {
      return (this.board = data);
    });
    this.loadImage(this.startGameConfig.board.srcMask).then((data) => {
      return (this.mask = data);
    });
  },
  beforeMount() {
    this.boardStyle = this.startGameConfig.board.cssStyle;
    this.svgStyle = this.startGameConfig.svg.cssStyle;
  },
  mounted() {
    this.mainBoard = this.$refs.board.getContext('2d');
    let image = new Image();
    image.src = this.getImageSrc(this.startGameConfig.board.srcBoard);
    image.addEventListener('load', () => {
      this.mainBoard.drawImage(image, 0, 0);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$backgroundWidth: 1920px;
$backgroundHeight: 1080px;
$backgroundOffsetTop: 0;
$backgroundOffsetLeft: 0;
.game-mz-labyrinth2 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  top: $backgroundOffsetTop;
  left: $backgroundOffsetLeft;
  height: $backgroundHeight;
  width: $backgroundWidth;
  .board {
    position: absolute;
    z-index: 1;
  }
  .svg {
    position: absolute;
    z-index: 2;
  }
}
</style>
